export const NoonReportDuplicateError = new Error("A report with the same 'Voyage number' and 'Date&Time' already exists. Duplicate registrations are not allowed. Please check 'Voyage number' and 'Date&Time'.");
export const CreateReportListEmptyResponseError = new Error("Server Error! createReportList response is empty.");
export const CreateReportListCountZeroError = new Error("Server Error! createReportList createdReportCount is 0.");
export const IncorrectInputError = new Error("Server Error! IncorrectInput");
export const Auth0Error = new Error("Server Error! Auth0Error");
export const FailGetUploadUrlError = new Error("Server Error! FailGetUploadUrl");
export const ServerError = new Error("Server Error! ServerError");
export const Exception = new Error("Server Error!");
